import React, { useCallback, useEffect, useState, useContext } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { FaExternalLinkAlt } from 'react-icons/fa'

import ProductListTable from '../../tables/product/product_list'
import FiltersComponent from '../../widgets/filters'
import { ApiHelper } from '../../../helpers/apihelper'

import * as Constants from './../../../helpers/constants'
import * as FiltersConstants from './../../widgets/filters/constants'
import AppConfigContext from '../../app_layout/app_config_context'
import ClickToCopy from '../../widgets/copy_onclick'

import './../../../static/css/products/product_list.css'

const initialStates = {
  prodList: [],
  filters: {
    renewal_interval: {
      filter_label: 'Billed',
      label: 'All',
      value: 'all'
    },
    status: {
      filter_label: 'Product Status',
      label: 'All',
      value: 'all'
    },
    currency: {
      filter_label: 'Currency',
      label: 'All',
      value: 'all'
    },

  }
}


const ProductList = () => {
  const [state, setState] = useState(initialStates)


  const appConfig = useContext(AppConfigContext)
  const client = appConfig.client

  const getProductList = useCallback(() => {
    let requestQueryParams = {
      limit: 100,
      skip: 0,
      total_required: true,
      filters: JSON.stringify({
        status: 'active',
        // is_custom: true
      }),
      client_secret: Constants.CLIENT_SECRET,
    }
    let queryParams = _.pick(requestQueryParams, ApiHelper(client, 'GET_PRODUCT_LIST').API_QUERY)

    ApiHelper(client, 'GET_PRODUCT_LIST').API(client, queryParams)
      .then((response) => {
        if (response && response.status === Constants.CO_API.SUCCESS) {
          let prodList = []

          if (!_.isEmpty(response.data.data.lists)) {
            prodList = response.data.data.lists.map(prod => { prod.id = prod._id; return prod })
          }
          setState((prevState) => ({
            ...prevState,
            prodList
          }))
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [client])

  useEffect(() => {
    getProductList()
  }, [getProductList])

  const clearSearch = () => {
    setState(prevState => ({ ...prevState, searchText: '' }))
  }

  const onSearch = (event) => {
    setState(prevState => ({ ...prevState, searchText: event.target.value }))
  }

  const onSetFilters = (filters) => {
    setState((prevState) => ({
      ...prevState,
      filters
    }))
  }

  const columns = [
    {
      label: 'Display Name',
      renderCell: (product) => {
        return (
          <div className="d-flex flex-column">
            <span>{product.display_name}</span>
            <span className="d-flex flex-row">
              {'Id: '}
              <span className="px-1">
                <ClickToCopy text={product._id} />
              </span>
              {product.recurring && product.type === 'plan' && (
                <a
                  href={`/${client}/plan_info/${product._id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="plan-info-link"
                >
                  <FaExternalLinkAlt size={12} />
                </a>
              )}
            </span>
          </div>
        )
      },
    },
    {
      label: 'Plan Type',
      renderCell: (product) => {
        return _.startCase(product.type)
      }
    },
    {
      label: 'Renewal',
      renderCell: (product) => {
        if (!product.renewal)
          return '-'

        return (
          <div className='d-flex flex-column'>
            <span>
              <span>Renewal Unit: </span>
              <span>{_.startCase(product.renewal.unit)}</span>
            </span>
            <span>
              <span>Rnewal Count: </span>
              <span>{product.renewal.count}</span>
            </span>
            <span>
              <span>Renewal Times: </span>
              <span>{product.renewal.times || 'Infinity'}</span>
            </span>
          </div>
        )
      }
    },
    {
      label: 'Price',
      renderCell: (product) => {
        let priceInUSD = product.price.total_price
        let priceInINR = product.price.total_price
        let exchangeRate = product.price.exchange_rate
        let version = product.version

        if (product.price.currency === 'INR')
          priceInUSD = product.price.price_in_usd

        return (
          <div className='d-flex flex-column'>
            <span>
              <span>Price in USD: </span>
              <span>{priceInUSD}</span>
            </span>
            {
              product.price.currency === 'INR'
                ?
                <>
                  <span>
                    <span>Price in INR: </span>
                    <span>{priceInINR}</span>
                  </span>
                  <span className='text-muted'>
                    <small>Exchange Rate: </small>
                    <small>{exchangeRate}</small>
                  </span>
                </>
                : null
            }
            <span className='text-muted'>
              <small>Version: </small>
              <small>v{version}</small>
            </span>
          </div>
        )
      }
    },
    {
      label: 'Currency',
      renderCell: (product) => {
        return product.price.currency
      }
    },
    {
      label: 'Custom',
      renderCell: (product) => {
        return product.is_custom.toString().toUpperCase()
      }
    },
    {
      label: 'Custom Users',
      renderCell: (product) => {
        if (!product.is_custom) {
          return '-';
        }

        if (product.is_custom) {
          if (!_.isEmpty(product.users))
            return (
              <div className='d-flex flex-column'>
                {
                  product.users.map((user_id, idx) => (
                    <a
                      key={idx}
                      className='text-decoration-none'
                      href={`/${client}/individual_user_info?user_id=${user_id}&user_type=individual`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      {user_id}
                    </a>
                  )
                  )
                }
              </div>
            )
          else
            return (
              <small className='text-muted'>NO USER ATTACHED</small>
            )
        }

        return null
      }
    },
    {
      label: 'Can Display',
      renderCell: (product) => {
        return product.can_display.toString().toUpperCase()
      }
    },
    {
      label: 'Created',
      renderCell: (product) => {
        return (
          <div className="d-flex flex-column">
            <span>{product.created_by}</span>
            <span>{moment(product.created_on).format('DD-MMM-YYYY @ h:mm:ss a')}</span>
          </div>
        )
      }
    }
  ]

  return (
    <div>
      <div className="page-header mb-2">
        <h1 className='m-0 header'>
          {Constants.CLIENTS[client.toUpperCase()].DISPLAY_NAME} Plan List
        </h1>
      </div>
      <div className="page-content">
        <FiltersComponent
          onSetFilters={onSetFilters}
          filterState={state.filters}
          onSearch={onSearch}
          clearSearch={clearSearch}
          searchValue={state.searchText}
          filters={FiltersConstants.PRODUCT_LIST_PAGE[client].filters}
          filtersToInclude={FiltersConstants.FILTERS_TO_INCLUDE[client].PRODUCT_LIST_PAGE}
          resetFilters={FiltersConstants.PRODUCT_LIST_PAGE[client].onResetFilters}
          client={client}
          className={'product-filters'}
        />
        <ProductListTable
          data={state.prodList}
          columns={columns}
        />
      </div>
    </div>
  )
}

export default ProductList